import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'modules';
import UserCourseTicketCard from 'components/user/UserCourseTicketCard';
import { StyledTitle } from 'components/user/UserCourseUsageHistory';
import { getCreditBalance } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import {
  EFinanceMembershipBalance,
  EMembershipBalance,
  FINANCE_MENTORING_COURSES_LIST,
  MENTORING_COURSES_LIST,
} from 'modules/mentoring';
import { CWindowWidth } from 'constants/base.const';
import { CMentoringFieldType } from 'constants/mentoring.const';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Button } from 'antd';
import styled from 'styled-components';
import { Colors, PrimaryColor, SecondaryColor, device } from 'GlobalStyles';

const UserCreditWrapper = styled.div`
  .btn-default {
    background: #fff !important;
    border-color: ${PrimaryColor} !important;
  }
`;

const UserCourseList = () => {
  const history = useHistory();
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  //좌상단 탭 이동에 따라 쿼리 파라미터로 consulting, finance 구분해서 balance 데이터 받음
  const getPromise = getCreditBalance.bind(null, {
    field: {
      mentoring_field: currentUser?.primary_field,
    },
  });
  const [{ data: creditBalance }] = useDataApi<{ [key: string]: string }>(getPromise.bind(null));

  return (
    <UserCreditWrapper>
      <div
        style={{
          maxWidth: `${CWindowWidth - 400}px`,
          margin: 'auto',
          padding: '40px 10px 0px 10px',
        }}
      >
        <StyledTitle>
          마이페이지 -{' '}
          {currentUser?.primary_field === EMentoringField.Consulting
            ? CMentoringFieldType[EMentoringField.Consulting]
            : CMentoringFieldType[EMentoringField.Finance]}
        </StyledTitle>
      </div>
      <div
        style={{
          maxWidth: `${CWindowWidth - 400}px`,
          padding: '20px 10px',
          margin: 'auto',
        }}
      >
        <StyledTicketGroups>
          <StyledTicketGroup>
            <StyledTicketGroupName>멘토링 수강권</StyledTicketGroupName>
            {/*컴포넌트로 만든다면? MENTORING_COURSES_LIST,creditBalance 만 전달하면됨?cardType, buttonPath도 전달해야함....  */}
            {/* 🌸 멘토링 수강권 - consulting*/}
            {currentUser?.primary_field === EMentoringField.Consulting &&
              MENTORING_COURSES_LIST?.map((el: { course_title: string; course_name: Array<string> }) => {
                return (
                  <UserCourseTicketCard
                    cardType={'mentoring_course_list'}
                    courseTitle={el.course_title}
                    courseName={el.course_name}
                    ticketBalance={creditBalance}
                    buttonPath={'/mentoring/program_about'}
                  />
                );
              })}
            {/* 🌸 멘토링 수강권 - finance*/}
            {currentUser?.primary_field === EMentoringField.Finance &&
              FINANCE_MENTORING_COURSES_LIST?.map(
                (el: { course_title: string; course_name: Array<string> }) => {
                  return (
                    <UserCourseTicketCard
                      cardType={'mentoring_course_list'}
                      courseTitle={el.course_title}
                      courseName={el.course_name}
                      ticketBalance={creditBalance}
                      buttonPath={'/mentoring/program_about'} //finance 프로그램 소개 페이지로 이동
                    />
                  );
                },
              )}
          </StyledTicketGroup>
          <StyledTicketGroup>
            <StyledTicketGroupName>그 외 수강권</StyledTicketGroupName>
            {/* 🌸 그 외 수강권 - consulting*/}
            {currentUser?.primary_field === EMentoringField.Consulting && (
              <>
                {!currentUser?.is_drill_membership &&
                  !currentUser?.is_active_for_excel_video &&
                  !currentUser.is_interview_master_class_basic_available && (
                    <div style={{ textAlign: 'center', color: Colors.grey2, marginBottom: '50px' }}>없음</div>
                  )}

                {currentUser?.is_drill_membership && (
                  <UserCourseTicketCard
                    cardType={'membership_list'}
                    courseTitle={'케이스 문제'}
                    courseName={[EMembershipBalance.caseQuiz]}
                    // ticketBalance={creditBalance}
                    membershipStartnDate={currentUser.drill_membership_start_at}
                    validDays={90}
                  />
                )}
                {currentUser?.is_active_for_excel_video && (
                  <UserCourseTicketCard
                    cardType={'membership_list'}
                    courseTitle={'엑셀 강의 영상'}
                    courseName={[EMembershipBalance.excelVideo]}
                    // ticketBalance={creditBalance}
                    membershipStartnDate={currentUser?.excel_video_date.start_date}
                    buttonPath={ERoute.ExcelClassPlayer.replace(':id', '0')}
                    validDays={90}
                  />
                )}
                {currentUser?.is_interview_master_class_basic_available && (
                  <UserCourseTicketCard
                    cardType={'membership_list'}
                    courseTitle={'전략컨설팅 인터뷰 MasterClass\n[기초편]'}
                    courseName={[EMembershipBalance.interviewMasterClassBasic]}
                    endDate={currentUser?.interview_master_class_basic_end_datetime}
                    buttonPath={ERoute.LectureInterviewMasterClassBasicVideoPlayer.replace(':videoId', '1')}
                  />
                )}
              </>
            )}
            {/* 🌸 그 외 수강권 - finance*/}
            {currentUser?.primary_field === EMentoringField.Finance && (
              <>
                {!currentUser?.is_finance_frameworks_membership && (
                  <div style={{ textAlign: 'center', color: Colors.grey2, marginBottom: '50px' }}>없음</div>
                )}

                {currentUser?.is_finance_frameworks_membership && (
                  <UserCourseTicketCard
                    cardType={'membership_list'}
                    courseTitle={'Frameworks'}
                    courseName={[EFinanceMembershipBalance.FinanceFrameworks]}
                  />
                )}
              </>
            )}
          </StyledTicketGroup>
        </StyledTicketGroups>

        <Button style={{ marginBottom: '200px' }} onClick={() => history.push(ERoute.UserCourseUsageHistory)}>
          수강권 사용내역
        </Button>
      </div>
    </UserCreditWrapper>
  );
};

export default UserCourseList;

const StyledTicketGroupName = styled.div`
  font-size: 16px;
  font-weight: 'bold';
  color: ${SecondaryColor};
`;

const StyledTicketGroups = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and ${device.lg} {
    flex-direction: column;
    align-items: start;
  }
`;

const StyledTicketGroup = styled.div`
  width: 100%;
  @media screen and ${device.lg} {
    width: 80%;
  }
  @media screen and ${device.sm} {
    width: 100%;
  }
`;
